import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import JoinForm from './components/JoinForm';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import CookiePolicy from './pages/CookiePolicy';
import ContentModerationPolicy from './pages/ContentModerationPolicy';

// Reserved routes where the form should not be shown
const reservedRoutes = [
  '/contact',
  '/about',
  '/privacy-policy',
  '/terms-of-service',
  '/cookie-policy',
  '/content-moderation-policy'
];

const App = () => {
  return (
    <Router>
      <Routes>
        {/* Reserved routes */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/join" element={<JoinForm />} />
        <Route path="/contact" element={<div>Contact Page</div>} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/content-moderation-policy" element={<ContentModerationPolicy />} />

        {/* Catch-all route for non-reserved pages */}
        <Route
          path=":username"
          element={
            reservedRoutes.includes(window.location.pathname) ? (
              <div>{window.location.pathname.replace('/', '')} Page</div> // Show reserved page content
            ) : (
              <JoinForm customPath={window.location.pathname.replace('/', '')} /> // Serve JoinForm for non-reserved routes
            )
          }
        />
      </Routes>
    </Router>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

export default App;
